export const burambaeva = {
  id: 'burambaeva',
  name: {
    ru: 'Бурамбаева Зауре Амангельдиновна',
    kz: 'Бурамбаева Зауре Амангельдиновна',
  },
  position: {
    ru: 'Медицинская сестра',
    kz: 'Мейіргер',
  },
  image: '/team_photoes/new/Зауре Амангельдиновна.svg',
  experience: {
    ru: '28 лет',
    kz: '28 жыл',
  },
  education: {
    ru: `Акмолинское городское медицинское училище — специальность Сестринское дело, категория Высшая`,
    kz: `Ақмола қалалық медицина училищесі, «Мейіргер ісі» мамандығы, санаты – жоғары`,
  },
  certificates: {
    ru: '',
    kz: '',
  },
  work: {
    ru: `• 1994–2023 — ГКП на ПХВ «Городская поликлиника №6» — Старшая медсестра / участковая медсестра
• 08.2023–04.2024 — Городская поликлиника №5 — Медицинская сестра
• 2024 — по настоящее время — ГККП «Спортивный медицинский центр города Астаны» — Медицинская сестра`,
    kz: `• 1994–2023 — «№6 қалалық емхана» ШЖҚ МКК – аға мейіргер / учаскелік мейіргер
• 08.2023–04.2024 — №5 қалалық емхана – мейіргер
• 2024 — қазіргі уақытқа дейін — Астана қаласының «Спорттық медицина орталығы» МКҚК – мейіргер`
  },
}; 